import { render, staticRenderFns } from "./editChartOfAccount.vue?vue&type=template&id=b70f4690&scoped=true&"
import script from "./editChartOfAccount.vue?vue&type=script&lang=js&"
export * from "./editChartOfAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70f4690",
  null
  
)

export default component.exports